import { render, staticRenderFns } from "./address-info.vue?vue&type=template&id=056ce0b0&scoped=true&"
import script from "./address-info.vue?vue&type=script&lang=js&"
export * from "./address-info.vue?vue&type=script&lang=js&"
import style0 from "./address-info.vue?vue&type=style&index=0&id=056ce0b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ce0b0",
  null
  
)

export default component.exports